import * as React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@avensia/excite';
import { addNavigationEventToDataLayer } from 'webapp/tracking/events/main-navigation';
import Image from 'webapp/components/image';
import { NnTestIdProps } from 'webapp/shared/test-ids';
import { LEVEL_WIDTH } from 'webapp/shell/main-menu/helpers';
import Link from 'webapp/components/Link';
import { isSvenssons } from 'webapp/theme';

type PropType = {
  level: NordicNest.Api.MenuItemApiModel;
  menu_category: string;
};

export const LevelHeading = ({ level, menu_category }: PropType) => {
  return (
    <ListHeading>
      {!level?.link?.to && (
        <>
          <Icon image={level.icon} /> <span>{level.link?.children}</span>
        </>
      )}
      {!level?.link?.to ? null : (
        <LinkHeading
          {...level.link}
          {...NnTestIdProps.MenuLevelHeading}
          onClick={() => addNavigationEventToDataLayer({ ...level, menu_type: 'side', menu_category })}
        >
          {level.link.to ? `${translate(t => t.mobileMenu.showAll)} ${level.link.children}` : ''}
        </LinkHeading>
      )}
    </ListHeading>
  );
};

const ListHeading = styled.h2(
  {
    padding: { x: t => (isSvenssons ? t.sharedSpacing.xxl : t.sharedSpacing.l) },
    margin: {
      bottom: t => (isSvenssons ? t.sharedSpacing.l : t.sharedSpacing.s),
      top: t => (isSvenssons ? t.sharedSpacing.s : t.sharedSpacing.xs),
    },
    width: LEVEL_WIDTH,
    fontSize: t => t.header?.fontSize,
    fontWeight: t => t.header?.fontWeight,
  },
  isSvenssons && {
    lineHeight: 1.2,
  },
);

const LinkHeading = styled(Link, {
  display: 'inline-block',
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'underline',
  },
});
const Icon = styled(Image, {
  maxHeight: '100%',
  width: 14,
  objectFit: 'contain',
  aspectRatio: '1/1',
  marginRight: t => t.sharedSpacing.xxs,
});
